export default __webpack_public_path__ + "static/media/schultenumbers_locked_crown.09a83bdc.svg";